// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 40px;
  margin-right: 10px;
`
const Img: StyledComponent<Object, any, any> = styled.div`
  background-size: cover;
  border: 1px solid #bfbfbf;
  width: 40px;
  height: 40px;
  overflow: hidden;
`

type Props = {|
  pictureUrl: string
|}

export default class AdImagePreview extends Component<Props> {
  render() {
    const { pictureUrl } = this.props
    return (
      <Wrapper>
        <Img style={{ backgroundImage: 'url(' + pictureUrl + ')' }} />
      </Wrapper>
    )
  }
}
